export default __webpack_public_path__ + "static/media/sf.501f2ac8.png";